<template>
  <button
    :class="['btn', 'button', 'flex-row-align-center']"
    @click="$emit('click')"
  >
    <icon v-if="icon" :size="18">{{ icon }}</icon>
    <slot />
  </button>
</template>

<script>
export default {
  props: {
    icon: String,
  },
};
</script>

<style lang="scss" scoped>
.btn {
  outline: none;
  i {
    margin-right: 5px;
  }
}
</style>
